import React from 'react'

const DealerSimplify = () => {
  return (
    <section id="c-sectionSimplifyExp">
		<div className="container">
			<div className="c-simplifyExpContent">
				<span className="c-heading40Bold c-simplifyExpLine">Simplify the experience.</span><br/>
				<span className="c-heading40Bold c-simplifyExpLine">Streamline the process.</span>
				<div className="c-clear"></div>
				<div className="row justify-content-center">
					<div className="col-md-6 col-12">
						<p className="c-para22Regular">Only one QR. You can avail EV-loans, fully AI powered.</p>				
					</div>					
				</div>

			</div>
		</div>
	</section>
  )
}

export default DealerSimplify